import { render, staticRenderFns } from "./catLayout.vue?vue&type=template&id=be75f746"
import script from "./catLayout.vue?vue&type=script&lang=js"
export * from "./catLayout.vue?vue&type=script&lang=js"
import style0 from "./catLayout.vue?vue&type=style&index=0&id=be75f746&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports